import { RootState } from "app/store";
import { casesSort } from "util/sortFunctions";

const taskTypesInOrder = [
  "accessioning",
  "grossing",
  "ship",
  "processing",
  "embedding",
  "cutting",
  "staining",
  "scanning",
];

export const workWithTaskIn =
  (type: string[] | string, clia_certificate_id?: number) =>
  (state: RootState) => {
    const typeArgs = [...[type]].flat();
    return Object.values(state.casesWithWork)
      .filter((c) =>
        c.work_processes.some((w) =>
          typeArgs.some((typeArg) => {
            for (let i = 0; i < taskTypesInOrder.length; i++) {
              const taskType = taskTypesInOrder[i];
              if (typeArg !== taskType) {
                // All existing tasks before the desired task must be completed
                if (
                  w.tasks.some((t) => t.type === taskType && !t.completed_at)
                ) {
                  return false;
                }
              } else {
                // The desired task must not be completed
                return w.tasks.some(
                  (t) => t.type === taskType && !t.completed_at
                );
              }
            }
            return false;
          })
        )
      )
      .filter((c) =>
        clia_certificate_id && // If the station's clia_certificate is not set, show all cases.
        c.grossed_by_cert_id // Similarly, if the case does not have any grossed_by_cert, show it on all stations
          ? c.grossed_by_cert_id === clia_certificate_id
          : true
      )
      .sort(casesSort(state.clinics));
  };
